export default function () {
    return (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2306_36731)">
                <path
                    d="M25.5 3.875H10.5C9.67157 3.875 9 4.54657 9 5.375V31.625C9 32.4534 9.67157 33.125 10.5 33.125H25.5C26.3284 33.125 27 32.4534 27 31.625V5.375C27 4.54657 26.3284 3.875 25.5 3.875Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15.75 7.25L20.25 7.25" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M19.6875 29.1875C19.6875 30.1195 18.932 30.875 18 30.875C17.068 30.875 16.3125 30.1195 16.3125 29.1875C16.3125 28.2555 17.068 27.5 18 27.5C18.932 27.5 19.6875 28.2555 19.6875 29.1875Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_2306_36731">
                    <rect width="36" height="36" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
